import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map, take } from 'rxjs';
import { authPersist, AuthRepository } from '../auth/state/auth.repository';

export const privateGuard: CanActivateFn = (route, state) => {
  const _router = inject(Router);
  const _authRepository = inject(AuthRepository);

  return combineLatest([
    _authRepository.token$,
    authPersist.initialized$,
  ]).pipe(
    take(1),
    map(([data]) => {
      if (data?.accessToken == null) {
        // If user has no token and tries to access private routes, redirect to login
        _router
          .navigate(
            ['public', 'login']
          )
          .then();
        return false;
      }
      return true;
    })
  );
};
